var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotification(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.83281 17.8H1.89142C1.19959 17.8 0.77227 17.1216 1.12821 16.5884L2.0983 15.1352C2.6815 14.2615 2.98957 13.2618 2.98957 12.2429V8.2C2.98957 4.22355 6.57596 1 11 1C15.424 1 19.0104 4.22355 19.0104 8.2V12.2429C19.0104 13.2618 19.3185 14.2615 19.9017 15.1352L20.8718 16.5884C21.2277 17.1216 20.8004 17.8 20.1086 17.8H14.1672M7.83281 17.8H14.1672M7.83281 17.8V18.1532C7.83281 19.7255 9.25081 21 11 21C12.7492 21 14.1672 19.7255 14.1672 18.1532V17.8",
    stroke: "currentColor",
    strokeOpacity: 0.8,
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotification);
export default __webpack_public_path__ + "static/media/notification.04b3f5f8084122a6fa358e02f009dc2c.svg";
export { ForwardRef as ReactComponent };